import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { useNotificationService } from '../../hooks/useNotificationService/useNotificationService';
import { useAuthGuard } from '../../features/hooks/useAuthGuard/useAuthGuard';
import MainDrawerLayout from '../../features/layouts/MainDrawerLayout/MainDrawerLayout';
import { useEntitySelect } from '../../features/hooks/useEntitySelect/useEntitySelect';

export const DrawerLayout = () => {
  useAuthGuard();
  useEntitySelect();
  useNotificationService();

  return (
    <MainDrawerLayout>
      <Suspense fallback={<div />}>
        <Outlet />
      </Suspense>
    </MainDrawerLayout>
  );
};
